import { render, staticRenderFns } from "./PROJECT_SWITCH.vue?vue&type=template&id=60cba690&scoped=true&"
import script from "./PROJECT_SWITCH.vue?vue&type=script&lang=js&"
export * from "./PROJECT_SWITCH.vue?vue&type=script&lang=js&"
import style0 from "./PROJECT_SWITCH.vue?vue&type=style&index=0&id=60cba690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cba690",
  null
  
)

export default component.exports